import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Icon, Modal } from "antd";
import { OrderedMap, Map } from "immutable";
import { INPUT_TYPES } from "constants";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import CompanyService from "./../services/company-los-services";
import moment from "moment";

const getFormFields = ({
    allFieldsDisabled
}) => new OrderedMap({
    id: {
        key: "id",
        label: "Id",
        dataIndex: "id",
        width: 0,
        type: INPUT_TYPES.NUMBER,
        className: "form-field d-none",
        disabled: true,
        trigger: "onBlur",
        valuePropName: "defaultValue"
        // onCell: record => ({
        //     record,
        //     key: "id",
        //     dataIndex: "id",
        //     label: "Id",
        //     field: {
        //     }
        // })
    },
    anchor: {
        key: "anchor",
        label: "Anchor",
        dataIndex: "anchor",
        type: INPUT_TYPES.OBJECT_SELECT,
        className: "form-field fb-30",
        disabled: allFieldsDisabled,
        labelProp: "name",
        showSearch: true,
        // onCell: record => ({
        //     record,
        //     label: "Total Turnover Current FY",
        //     dataIndex: "anchor",
        //     field: {
        //     }
        // })
    },
    financial_year: {
        key: "financial_year",
        label: "FY",
        dataIndex: "financial_year",
        className: "form-field fb-30",
        type: INPUT_TYPES.SELECT,
        disabled: allFieldsDisabled,
        labelProp: "name",
        // onCell: record => ({
        //     record,
        //     label: "FY",
        //     dataIndex: "financial_year",
        //     field: {
        //     }
        // })
    },
    end_date: {
        key: "end_date",
        label: "Till Date",
        dataIndex: "end_date",
        type: INPUT_TYPES.DATE,
        className: "form-field fb-30",
        disabled: allFieldsDisabled
        // onCell: record => ({
        //     record,
        //     label: "Till Date",
        //     dataIndex: "end_date",
        //     field: {
        //     }
        // })
    },
    amount: {
        key: "amount",
        label: "Total Turnover With Anchor",
        dataIndex: "amount",
        type: INPUT_TYPES.TEXT,
        isAmountField: true,
        className: "form-field fb-30",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue"
        // onCell: record => ({
        //     record,
        //     label: "Total Turnover With Anchor",
        //     dataIndex: "amount",
        //     field: {
        //     }
        // })
    },
    // cancel: {
    //     key: "cancel",
    //     label: "",
    //     dataIndex: "cancel",
    //     type: INPUT_TYPES.BUTTON,
    //     btnLabel: "Cancel",
    //     btnType: "link"
    // onCell: record => ({
    //     record,
    //     label: "Cancel",
    //     dataIndex: "cancel",
    //     field: {
    //     }
    // })
    // }
});


class CompanyAnnualTurnoversForm extends React.Component {
    state = {
        financialYears: null,
        turnoverIds: new Map({}),
        removedTurnovers: [],
        addedTurnovers: false
    }
    formFields = getFormFields({ allFieldsDisabled: this.props.loading });
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    componentDidMount() {
        CompanyService.fetchFinancialYears().then((_) => {
            this.setState({
                financialYears: _.data.map(_ => ({
                    label: _.name,
                    value: _.id
                }))
            });
        });
        // if(!this.state.turnoverIds.size) {
        //     this.toggleFormGrid("ADD");
        // }
    }

    // componentDidUpdate() {
    //     if(this.props.values && this.props.values.length && !this.state.addedTurnovers) {
    //         const values = new List(this.props.values)
    //             .toMap()
    //             .mapEntries(([, v]) => [v.id, v]);
    //         this.setState({
    //             turnoverIds: values.map((_, k) => {
    //                 return {
    //                     ..._,
    //                     end_date: _.end_date && moment(_.end_date),
    //                     financial_year: _.financial_year && _.financial_year.id,
    //                     key: k,
    //                     index: k
    //                 };
    //             }),
    //             addedTurnovers: true
    //         });
    //     }
    // }

    // toggleFormGrid = (action = "ADD", id) => {
    //     const { turnoverIds } = this.state;
    //     let removedTurnovers = this.state.removedTurnovers;
    //     const newID = shortID();
    //     switch (action) {
    //     case "ADD":
    //         this.setState({
    //             turnoverIds: turnoverIds.set(newID, {...new CompanyAnnualTurnover().toJS(), key: newID, index: newID})
    //         });
    //         break;
    //     case "REMOVE": {
    //         removedTurnovers.push(id);
    //         this.setState({
    //             removedTurnovers: removedTurnovers
    //         });
    //         break;
    //     }
    //     default:
    //     }
    // };

    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, values) => {
                if (!err) {
                    let newValues = values;
                    newValues.end_date = newValues.end_date && newValues.end_date.format("YYYY-MM-DD");
                    newValues.anchor = newValues.anchor && newValues.anchor.id;
                    this.props.onValuesSubmit(newValues);
                }
            });
        }
    }

    onSearchAnchor = (val) => {
        return CompanyService.getCompanyLosProfiles({
            page: 1,
            page_size: 20,
            search: val,
            type: 1
        }).then(({data}) => {
            return {
                data: data && data.results
            };
        });
    }

    // tableFormCell = () => props => {
    //     const { dataIndex, record, field, ...restProps } = props;
    //     if(dataIndex === "anchor") {
    //         field.onSearch = this.onSearchAnchor;
    //     }
    //     if(dataIndex === "financial_year") {
    //         field.options = this.state.financialYears || [];
    //     }
    //     const index = record.index;
    //     return (
    //         <td {...restProps}>
    //             {this.fieldGenerator(
    //                 `[${index}].${dataIndex}`,
    //                 { ...field, defaultValue: record[dataIndex] },
    //                 this.getValidateStatus(dataIndex)
    //             )()}
    //         </td>);
    // }
    // tableCell = this.tableFormCell(this.props.form);
    render() {
        return (
            <Modal
                width={800}
                bodyStyle={{
                    paddingRight: "3rem",
                    paddingLeft: "3rem"
                }}
                footer={null}
                title="Add/Update Annual Turnover"
                visible={this.props.visible}
                onCancel={this.props.toggleTurnOverModal}
            >
                <Form onSubmit={this.onValuesSubmit}>
                    <div className={"form-row align-items-center"}>
                        {this.formFields.map((field, fieldName) => {
                            if(fieldName === "anchor") {
                                field.onSearch = this.onSearchAnchor;
                            }
                            if(fieldName === "financial_year") {
                                field.options = this.state.financialYears || [];
                            }
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                this.getValidateStatus(fieldName)
                            )();
                        }).toList()}
                    </div>
                    <div className={"form-row flex-row-reverse p-10"}>
                        <Button type={"primary"} htmlType={"submit"}>
                            {this.props.loading ? <Icon type={"loading"} /> : null}
                            Add/Update
                        </Button>
                    </div>
                </Form>
            </Modal>
        // <Form onSubmit={this.onValuesSubmit}>
        //     <div className={"form-row align-items-center"}>
        //         <Table
        //             style={{
        //                 width: "100%"
        //             }}
        //             components={
        //                 body
        //             }
        //             scroll={{
        //                 x: true
        //             }}
        //             className={"table-padding"}
        //             key={"id"}
        //             dataSource={
        //                 this.state.turnoverIds.toList().toArray()
        //             }
        //             columns={this.formFields.toList().toArray()}
        //             footer={null}
        //             pagination={false}
        //         />
        //     </div>
        //     <div className={"form-row flex-row-reverse p-10"}>
        //         <Button type={"primary"} htmlType={"submit"}>
        //             {this.props.loading ? <Icon type={"loading"} /> : null}
        //             Update
        //         </Button>
        //         <Button className={"mr-5"} onClick={this.toggleFormGrid.bind(null, "ADD")}>
        //             <Icon type={"plus"} />
        //             Add New
        //         </Button>
        //     </div>
        // </Form>
        );
    }
}

CompanyAnnualTurnoversForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.array,
    onValuesSubmit: PropTypes.func,
    loading: PropTypes.bool,
    toggleTurnOverModal: PropTypes.func,
    visible: PropTypes.bool,
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
                    values
                        .toSeq()
                        .toMap()
                        .map((value, key) => {
                            if(key === "financial_year"){
                                value = value && value.id;
                            }
                            if(key === "end_date"){
                                value = (value && moment(value)) || null;
                            }
                            let message = null;
                            if (value === null) {
                                message = "Field cannot be empty";
                            }
                            if (message) {
                                return Form.createFormField({
                                    value,
                                    errors: [{ message }]
                                });
                            } else {
                                return Form.createFormField({
                                    value
                                });
                            }
                        }).toJS();
    }
})(CompanyAnnualTurnoversForm);